import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AddUpdateUserModal from "./AddUpdateUserModal";
import ThemeTable from "../ThemeTable/ThemeTable";
import UpdateUserPluginModalAccessNew from "../PluginsAccessModal/UpdateUserPluginModalAccessNew";
import {
  getPluginsList,
  getUsersList,
  getAssistant,
  updateUserPlugin,
  addUserForPlugin,
} from "../../api/users.api";
import WelcomeMessage from "../Dashboard/WelcomeMessage";
import BreadCrumb from "../BreadCrum/BreadCrumb";
import AssistantHeader from "../AssistantHeader/AssistantHeader";
import { userService } from "../../services/user.service";
import Utils from "../../utils/index.js";
import { t } from "i18next";
import { toast } from "react-toastify";
import NotFoundFiles from "../FileAnalyzer/NotFoundFiles.js";
import Form from "react-bootstrap/Form";

const UserListRightSection = ({ isMenuOpen, toggleMenu }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const UuId = queryParams.get("uuid");
  const pageLimit = 10;
  const [assistantDetail, setAssistantDetail] = useState({});
  const [loader, setLoader] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [usersList, setUsersList] = useState([]);
  const [pluginsList, setPluginsList] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showUserPluginModal, setShowUserPluginModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [operationType, setOperationType] = useState(null);
  const [modalState, setModalState] = useState(0);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");
  const [totalUserAssistants, settotalUserAssistants] = useState(0);
  const navigate = useNavigate();
  const { page = 1 } = useParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [isPublic, setIsPublic] = useState(false);
  // const user = getUser();
  const userId = userService.getUserData();
  useEffect(() => {
    if (!userId) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (UuId) {
      getAssistantDetails(UuId);
      getAllUsersList(UuId);
      getAllPluginsList();
    }
  }, [page]);

  useEffect(() => {
    getAllUsersList(UuId);
  }, [searchQuery]);

  const addUser = async () => {
    try {
      const response = await addUserForPlugin({
        firstName,
        lastName,
        role: modalState == 2 ? "USER" : modalState == "C" ? "CCMGR" : "ADMIN",
        orgId: JSON.parse(Utils.getLocalStorageItem("currentUser"))?.orgId,
        projectId: UuId,
        emailId: email,
        active: true,
      });
      if (response?.success && response?.statusCode === 200) {
        //   setEmail('')
        //   setModalState(0)
        //   setOperationType(null);
        //   getAllUsersList(UuId);

        if (modalState == "C") {
          setModalState("C1");
        } else {
          setModalState(modalState + 2);
        }
      }
    } catch (error) {
      setError(error);
      setTimeout(() => {
        setError("");
      }, 5000);
    }
  };

  const handleToggle = async () => {
    try {
      const newPublic = !isPublic;
      const data = newPublic ? null : { rolecode: "ENDUSER", emailid: "all" };

      await updateUserPluginOnClick(data);
      setIsPublic(newPublic);
    } catch (error) {
      console.error(error);
    }
  };

  const updateUserPluginOnClick = async (data) => {
    try {
      let payload = {
        useremailid: email ? email : "all",
        orgid: assistantDetail?.orgId,
        assistantuuid: UuId,
        adminemailid: JSON.parse(Utils.getLocalStorageItem("currentUser"))
          ?.emailID,
        event: "add",
        role:
          !operationType || (operationType === "Manage" && modalState == 2)
            ? "ENDUSER"
            : operationType == "Manage" && modalState == 3
            ? "ADMIN"
            : operationType == "Manage" && modalState == "C"
            ? "CMGR"
            : "",
      };
      if (data) {
        payload.event = "delete";
        payload.role = data?.rolecode;
        payload.useremailid = data?.emailid;
      }
      const response = await updateUserPlugin(payload);
      if (response?.success && response?.statusCode === 200) {
        const toastMessage =
          payload.useremailid === "all"
            ? !data
              ? "Assistant published to all users"
              : "Assistant unpublished from all users"
            : `User${data ? "" : "'s"} successfully ${
                data ? "deleted" : "assigned"
              }.`;

        toast.success(toastMessage);
        setEmail("");
        setModalState(0);
        setOperationType(null);
        getAllUsersList(UuId);
        setSelectedUser(null);
        setShowUserModal(false);
      } else if (!response?.success && response?.statusCode === 200) {
        setError(response?.message);

        setTimeout(() => {
          setError("");
        }, 6000);
      }
    } catch (error) {
      setError(error);
      setTimeout(() => {
        setError("");
      }, 6000);
      // setEmail("");
      // setModalState(0);
      // setOperationType(null);
    }
  };
  const getAssistantDetails = async (id) => {
    try {
      setLoader(true);
      const response = await getAssistant(id);
      const { data } = response || {};
      const assistantDetailData = data;
      // console.log(response,data,assistantDetailData)
      if (assistantDetailData) {
        setAssistantDetail(assistantDetailData);
        setIsPublic(response?.isPublic || false);
      }
    } catch (error) {
      setUsersList([]);
    } finally {
      setLoader(false);
    }
  };
  const getAllUsersList = async (uuid) => {
    try {
      setLoader(true);
      const response = await getUsersList(
        page - 1,
        pageLimit,
        uuid,
        searchQuery.trim()
      );
      const { data } = response || {};
      const { totalUserAssistants, limit, data: listData } = data || {};
      if (response?.success && response?.statusCode === 200) {
        // let checkPages=Math.trunc(totalUserAssistants/limit)
        // let totalPagesCount=(totalUserAssistants%limit!=0)?((checkPages)+1):(checkPages)
        setUsersList(listData);
        setTotalPages(totalUserAssistants);
        settotalUserAssistants(data.totalUserAssistants);
      } else {
        setUsersList([]);
      }
    } catch (error) {
      setUsersList([]);
    } finally {
      setLoader(false);
    }
  };

  const getAllPluginsList = async () => {
    try {
      // debugger;
      const response = await getPluginsList(0, 0, true);
      const { data } = response || {};
      const { totalNo, plugins } = data || {};
      if (response?.success && response?.statusCode === 200) {
        setPluginsList(plugins);
        // updateSelectedPlugins(plugins);
      } else {
        setPluginsList([]);
      }
    } catch (error) {
      setPluginsList([]);
    }
  };
  const columns = [
    {
      title: "Name",
      field: ["username", "emailid"],
      checkbox: false,
      imgUrlField: "imageUrl",
      nameInitial: true,
    },
    {
      title: "Role",
      field: ["rolename"],
      titleIcon: "QuestionMark",
    },
    {
      title: "Email Address",
      field: ["emailid"],
    },
    {
      title: null,
      onClick: (e) => updateUserPluginOnClick(e),
      fieldIcon: "DeleteButton",
    },
  ];
  // const columns = [
  //   {
  //     title: "#",
  //     autoIncrement: true,
  //   },
  //   {
  //     title: "Name",
  //     field: "firstName,lastName",
  //   },
  //   {
  //     title: "Email",
  //     field: "emailID",
  //   },
  //   {
  //     title: "Role",
  //     field: "role",
  //   },
  //   {
  //     title: "Plugin Access",
  //     field: null,
  //     //   className: "w-25",
  //     style: {
  //       maxWidth: 300,
  //     },
  //     render: (row) => (
  //       <UpdateUserPluginModalAccessNew
  //         pluginsList={pluginsList}
  //         //   show={showUserPluginModal}
  //         selectedUser={row}
  //         onUpdateDone={onUpdatePluginsAccess}
  //         setSelectedUser={setSelectedUser}
  //         //   onClose={() => {
  //         //     setSelectedUser(null);
  //         //     setShowUserPluginModal(false);
  //         //   }}
  //       />
  //     ),
  //   },
  // ];

  const actions = [
    {
      name: "Edit",
      onClick: (row) => {
        setSelectedUser({ ...row });
        setOperationType("Update");
        setShowUserModal(true);
      },
    },
    // {
    //   name: "Update Plugins",
    //   onClick: (row) => {
    //     // debugger;
    //     setSelectedUser({ ...row });
    //     setShowUserPluginModal(true);
    //   },
    // },
  ];

  const onUserUpdateDone = () => {
    setShowUserModal(false);
    setSelectedUser(null);
    getAllUsersList();
    getAllPluginsList();
  };

  const onUpdatePluginsAccess = () => {
    setShowUserPluginModal(false);
    setSelectedUser(null);
    getAllUsersList();
    getAllPluginsList();
  };

  return (
    <>
      {/* <div className='mobile-head'>
        <span className='togle'  onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="rgba(0,0,0,1)"><path d="M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"></path></svg>
          {isMenuOpen ? 'Menu' : 'Menu'}
        </span>
    </div> */}
      <WelcomeMessage title={assistantDetail?.assistantName} />
      <div className="user-assistantsection">
        <div className="breadcrub-head flex-wrap d-flex justify-content-between align-items-center">
          <BreadCrumb path={[assistantDetail?.assistantName, "Manage"]} />
          <button
            className="builder-btn btn btn-primary"
            onClick={() => navigate(`/assistant/launch?uuid=${UuId}`)}
          >
            {t("usethisAssistant")}{" "}
            <svg
              className="arrow-icon-dimesions"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M4.16675 9.99935H15.8334M15.8334 9.99935L10.0001 4.16602M15.8334 9.99935L10.0001 15.8327"
                stroke="#0061AF"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <AssistantHeader assistantDetail={assistantDetail} />
      <div className="mid-content  assistant-user-list">
        <div className="wraper-tab d-flex flex-column">
          <div className=" table-header-sec d-flex align-items-center justify-content-between flex-wrap gap-3">
            <h4 className="d-flex align-items-center gap-2">
              {t("assistantsUsedBy")}{" "}
              <span className="pill">
                {totalPages} {t("users")}
              </span>
            </h4>
            <div className="btn-wrap-user gap-3 d-flex align-itemes-center">
              {assistantDetail.ownerId &&
                assistantDetail.ownerId === JSON.parse(userId).emailID && (
                  <div className="d-flex align-items-center gap-2 public-btn">
                    <label htmlFor="custom-switch">Public</label>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      checked={isPublic}
                      onChange={handleToggle}
                    />
                  </div>
                )}
              <div className="form-input-wrapper search-filter d-flex align-items-center gap-2s">
                <input
                  value={searchQuery}
                  className="form-control random"
                  onChange={(event) => {
                    setSearchQuery(event.target.value);
                    navigate(`/users/1?uuid=${UuId}`);
                  }}
                  placeholder="Search"
                  maxLength={322}
                />

                <button
                  className="search-cion"
                  type="button"
                  id="button-addon2"
                >
                  {searchQuery == "" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="rgba(0,0,0,1)"
                      // onClick={()=>setSearchOption("")}
                    >
                      <path d="M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM11 18C14.8675 18 18 14.8675 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18ZM19.4853 18.0711L22.3137 20.8995L20.8995 22.3137L18.0711 19.4853L19.4853 18.0711Z"></path>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="rgba(0,0,0,1)"
                      onClick={() => setSearchQuery("")}
                    >
                      <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"></path>
                    </svg>
                  )}
                </button>
              </div>
              <button
                onClick={() => {
                  setOperationType("Manage");
                  setShowUserModal(true);
                  setModalState(1);
                  setEmail("");
                  setFirstName("");
                  setLastName("");
                }}
                className="table-btn"
              >
                {t("assignUser")}{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M2.5 6.66602L12.5 6.66602M12.5 6.66602C12.5 8.04673 13.6193 9.16602 15 9.16602C16.3807 9.16602 17.5 8.04673 17.5 6.66602C17.5 5.2853 16.3807 4.16602 15 4.16602C13.6193 4.16602 12.5 5.2853 12.5 6.66602ZM7.5 13.3327L17.5 13.3327M7.5 13.3327C7.5 14.7134 6.38071 15.8327 5 15.8327C3.61929 15.8327 2.5 14.7134 2.5 13.3327C2.5 11.952 3.61929 10.8327 5 10.8327C6.38071 10.8327 7.5 11.952 7.5 13.3327Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              {/* <button
                onClick={() => {
                  setOperationType("Add");
                  setShowUserModal(true);
                  setModalState(1);
                  setEmail("");
                  setFirstName("");
                  setLastName("");
                }}
                className="table-btn"
                // disabled={true}
              >
                Add User{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <g clip-path="url(#clip0_496_7697)">
                    <path
                      d="M10.0001 6.66602V13.3327M6.66675 9.99935H13.3334M18.3334 9.99935C18.3334 14.6017 14.6025 18.3327 10.0001 18.3327C5.39771 18.3327 1.66675 14.6017 1.66675 9.99935C1.66675 5.39698 5.39771 1.66602 10.0001 1.66602C14.6025 1.66602 18.3334 5.39698 18.3334 9.99935Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_496_7697">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button> */}
            </div>
          </div>
          <div className="overflow-auto table-theme">
            {usersList.length ? (
              <ThemeTable
                totalUserAssistants={totalUserAssistants}
                columns={columns}
                actions={actions}
                data={usersList}
                loader={loader}
                emptyMessage="No users found"
                page={page}
                pageLimit={pageLimit}
                totalRows={totalPages}
                onPageChange={(page) => {
                  navigate(`/users/${page}?uuid=${UuId}`);
                }}
                onClickDelete={updateUserPluginOnClick}
                assistantOwnerId={
                  assistantDetail.ownerId || assistantDetail.emailId
                }
              />
            ) : (
              <NotFoundFiles message={t("noUserFound")} />
            )}
          </div>
        </div>
      </div>
      {showUserModal && (
        <AddUpdateUserModal
          show={showUserModal}
          operationType={operationType}
          updateUserPluginOnClick={updateUserPluginOnClick}
          selectedUser={selectedUser}
          onUpdateDone={onUserUpdateDone}
          addUser={addUser}
          onClose={() => {
            setSelectedUser(null);
            setShowUserModal(false);
            setModalState(2);
          }}
          modalState={modalState}
          setModalState={setModalState}
          email={email}
          setEmail={setEmail}
          firstName={firstName}
          setFirstName={setFirstName}
          lastName={lastName}
          setLastName={setLastName}
          error={error}
          assistantuuid={UuId}
        />
      )}
    </>
  );
};

export default UserListRightSection;
